/* src/app/master-data/business/business-list/business-list.component.css */
/*# sourceMappingURL=business-list.component-KVN62QUW.css.map */
